import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Link, Text } from '@chakra-ui/react';
import { BB_MENU_IDS } from '@whitbread-eos/api';
import { ChevronRight, Icon } from '@whitbread-eos/atoms';
import { formatDataTestId, formatTextWithSpace, logout } from '@whitbread-eos/utils';
import NextLink from 'next/link';
import NavigationItem from '../../../HeaderLeisure/NavigationMenuMobile/NavigationItem';
import { containerItemStyle } from '../../../HeaderLeisure/NavigationMenuMobile/NavigationMenuMobile.style';
import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
export default function MobileNavitem(_ref) {
  var navTitleLabel = _ref.navTitleLabel,
    navigationLabels = _ref.navigationLabels,
    baseDataTestId = _ref.baseDataTestId,
    toggleSideNav = _ref.toggleSideNav,
    isLogoutButton = _ref.isLogoutButton;
  var findLabel = (title, labels) => {
    return labels.find(item => item.navTitle === title);
  };
  var isCompanyLabel = (title, labels) => {
    var labelItem = findLabel(title, labels);
    if (labelItem) {
      return labelItem.id === BB_MENU_IDS.COMPANY || labelItem.id === BB_MENU_IDS.COMPANY_NAME;
    }
  };
  var hasSubNav = (title, labels) => {
    var _labelItem$subNav;
    var labelItem = findLabel(title, labels);
    if ((labelItem === null || labelItem === void 0 || (_labelItem$subNav = labelItem.subNav) === null || _labelItem$subNav === void 0 ? void 0 : _labelItem$subNav.length) !== 0) {
      var _labelItem$subNav$0$n;
      return (labelItem === null || labelItem === void 0 ? void 0 : labelItem.subNav) && ((_labelItem$subNav$0$n = labelItem.subNav[0].navOptions) === null || _labelItem$subNav$0$n === void 0 ? void 0 : _labelItem$subNav$0$n.length) !== 0;
    }
  };
  var clickAction;
  var testId;
  var content;
  if (isLogoutButton(navTitleLabel)) {
    clickAction = logout;
    testId = 'MobileLogoutButton';
    content = _jsx(Link, {
      style: {
        textDecoration: 'none'
      },
      children: _jsx(Text, {
        children: navTitleLabel
      })
    });
  } else if (hasSubNav(navTitleLabel, navigationLabels)) {
    clickAction = () => toggleSideNav(navTitleLabel);
    testId = 'TriggerSideNav';
    content = _jsx(NavigationItem, {
      title: navTitleLabel,
      icon: _jsx(Box, {
        pt: "0.37rem",
        pl: "sm",
        children: _jsx(Icon, {
          svg: _jsx(ChevronRight, {})
        })
      })
    });
  } else {
    var _findLabel$url, _findLabel;
    testId = 'MobileLink';
    content = _jsx(NextLink, {
      href: (_findLabel$url = (_findLabel = findLabel(navTitleLabel, navigationLabels)) === null || _findLabel === void 0 ? void 0 : _findLabel.url) !== null && _findLabel$url !== void 0 ? _findLabel$url : '/',
      passHref: true,
      legacyBehavior: true,
      children: _jsx(Text, {
        children: navTitleLabel
      })
    });
  }
  return _createElement(Box, _objectSpread(_objectSpread(_objectSpread({
    onClick: clickAction
  }, customContainerItemStyle), isCompanyLabel(navTitleLabel, navigationLabels) && customCompanyStyle), {}, {
    "data-testid": formatDataTestId(baseDataTestId, formatTextWithSpace("".concat(navTitleLabel, "-").concat(testId))),
    key: "navItem-".concat(navTitleLabel)
  }), content);
}
var customCompanyStyle = {
  bgColor: '#F8F8F8'
};
var customContainerItemStyle = _objectSpread(_objectSpread({}, containerItemStyle), {}, {
  flexDirection: 'column',
  ml: '0',
  pl: 'md',
  w: '100%'
});